export default __webpack_public_path__ + "static/media/LO01.157a23c7.mp3";